import PropTypes from 'prop-types';
import styled from 'styled-components';

const StyledFlexBox = styled.div(
	{},
	({ style, $display, $flexDirection, $flexWrap, $justifyContent, $alignItems, $alignContent, $disabled }) => ({
		style,
		alignItems: $alignItems,
		display: $display,
		flexDirection: $flexDirection,
		flexWrap: $flexWrap,
		justifyContent: $justifyContent,
		alignContent: $alignContent,
		opacity: $disabled ? 0.4 : 1
	})
);

StyledFlexBox.propTypes = {
	$display: PropTypes.oneOf(['flex', 'inline-flex']),
	$flexDirection: PropTypes.oneOf(['row', 'row-reverse', 'column', 'column-reverse']),
	$flexWrap: PropTypes.oneOf(['nowrap', 'wrap', 'wrap-reverse']),
	$justifyContent: PropTypes.oneOf([
		'flex-start',
		'flex-end',
		'center',
		'space-between',
		'space-around',
		'space-evenly',
		'start',
		'end',
		'left',
		'right'
	]),
	$alignItems: PropTypes.oneOf(['stretch', 'flex-start', 'flex-end', 'center', 'baseline']),
	$alignContent: PropTypes.oneOf([
		'flex-start',
		'flex-end',
		'center',
		'space-between',
		'space-around',
		'space-evenly',
		'stretch',
		'start',
		'end',
		'baseline'
	]),
	style: PropTypes.object,
	$disabled: PropTypes.bool
};

StyledFlexBox.defaultProps = {
	$display: 'flex',
	style: {},
	$flexDirection: 'row',
	$flexWrap: 'nowrap',
	$justifyContent: 'flex-start',
	$alignItems: 'flex-start',
	$alignContent: 'flex-start',
	$disabled: false
};

export default StyledFlexBox;
